/* src/app/common/mpos-entity/components/di-create-edit-header/di-create-edit-header.component.scss */
:host {
  display: flex;
  flex: 1 0 0%;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  align-content: center;
  min-height: 60px;
  padding: 18px 12px 12px 12px;
  flex-wrap: nowrap;
}
#button-create-edit-header-back * {
  color: #000;
  fill: #000;
}
/*# sourceMappingURL=data:application/json;base64,ewogICJ2ZXJzaW9uIjogMywKICAic291cmNlcyI6IFsic3JjL2FwcC9jb21tb24vbXBvcy1lbnRpdHkvY29tcG9uZW50cy9kaS1jcmVhdGUtZWRpdC1oZWFkZXIvZGktY3JlYXRlLWVkaXQtaGVhZGVyLmNvbXBvbmVudC5zY3NzIl0sCiAgInNvdXJjZXNDb250ZW50IjogWyI6aG9zdCB7XG4gICAgZGlzcGxheTogZmxleDtcbiAgICBmbGV4OiAxIDAgMCU7XG4gICAgZmxleC1kaXJlY3Rpb246IHJvdztcbiAgICBqdXN0aWZ5LWNvbnRlbnQ6IHNwYWNlLWJldHdlZW47XG4gICAgYWxpZ24taXRlbXM6IGNlbnRlcjtcbiAgICBhbGlnbi1jb250ZW50OiBjZW50ZXI7XG5cbiAgICBtaW4taGVpZ2h0OiA2MHB4O1xuICAgIC8vIGJvcmRlci1ib3R0b206IDFweCBzb2xpZCAjZTRlOWYwO1xuICAgIHBhZGRpbmc6IDE4cHggMTJweCAxMnB4IDEycHg7XG4gICAgZmxleC13cmFwOiBub3dyYXA7XG59XG4gI2J1dHRvbi1jcmVhdGUtZWRpdC1oZWFkZXItYmFja3tcbiAgICAqe1xuICAgICAgICBjb2xvcjogIzAwMDtcbiAgICAgICAgZmlsbDogIzAwMDtcbiAgICB9XG4gfSJdLAogICJtYXBwaW5ncyI6ICI7QUFBQTtBQUNJLFdBQUE7QUFDQSxRQUFBLEVBQUEsRUFBQTtBQUNBLGtCQUFBO0FBQ0EsbUJBQUE7QUFDQSxlQUFBO0FBQ0EsaUJBQUE7QUFFQSxjQUFBO0FBRUEsV0FBQSxLQUFBLEtBQUEsS0FBQTtBQUNBLGFBQUE7O0FBR0EsQ0FBQSwrQkFBQTtBQUNJLFNBQUE7QUFDQSxRQUFBOzsiLAogICJuYW1lcyI6IFtdCn0K */
